import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
import { metaTag } from "../Library/commomLib";
const HofComponent = React.lazy(() => import("../Components/RootComponents/HofComponent"));
const HofPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <HofComponent />
      </Suspense>
    </Fragment>
  );
};

export default HofPage;
